export default __webpack_public_path__ + "static/media/Newsily logo-black.abbc6e4a.png";